import type { RouteRecordRaw } from 'vue-router'

/** Cesty sú po slovensky — sú súčasťou UI, kód a API zostávajú anglické. */
export const configuratorRoutes: RouteRecordRaw[] = [
	{
		path: '/konfigurator',
		name: 'configurator',
		component: () => import('./ConfiguratorPage.vue'),
		meta: { titleSk: 'Konfigurátor', requiresAuth: true },
	},
]
